import gql from 'graphql-tag';

export default gql`
    query GetMaxStage($jobId: Int, $wellHead: String) {
        getMaxStage(jobId: $jobId, wellHead: $wellHead) {
            count
        }
    }
`;
